import type { SerializedStyles } from '@emotion/react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

import Table from '@app/components/Table';
import theme from '@app/styles/theme';

export const DetailTable = styled(Table)`
  font-size: ${theme.fontSizes[2]};
  & tbody {
    & th {
      text-align: left;
    }

    & td,
    & th {
      border-bottom: 1px solid ${theme.colors.lightGray};
    }
  }
`;

DetailTable.defaultProps = { alternateRows: false };

export const alignEnd: SerializedStyles = css`
  text-align: end;
`;
